<ng-container *ngIf="data; else noData">
  <gtd-ui-field-default-money [data]="data.amount" [currencyCode]="data.currency"></gtd-ui-field-default-money>
</ng-container>
<ng-template #noData>
  <gtd-ui-field-default-money [data]="data?.amount || 0"></gtd-ui-field-default-money>
</ng-template>
